import { FC } from 'react';
import { IressButton, IressIcon, IressTable, IressText } from '@iress-oss/ids-components';
import '../../styles/CurrentPlanProjectionsTable.css';
import { useNavigate } from 'react-router';
import { CurrentPlanProjection, Nullable } from '@xplan-pension-switching/common';
import { isNullOrUndefinedOrEmpty } from '../../helpers/IsNullOrUndefinedOrEmpty/IsNullOrUndefinedOrEmpty';
import { columnDefs, CurrentPlanProjectionsTableProps } from './CurrentPlanProjectionsTableColDefs';

const useProjectionsTableRows = (
    currentPlanProjections: CurrentPlanProjection[],
    entityId: number,
    scenarioId: Nullable<number>,
    ownerId: Nullable<number>
) => {
    const navigate = useNavigate();

    return currentPlanProjections.map(item => ({
        ...item,
        nameCell: (
            <IressButton
                mode="link"
                onClick={() =>
                    navigate(
                        `./details?entityid=${entityId}&scenarioId=${scenarioId}&projectionId=${item.id}&ownerId=${ownerId}`
                    )
                }
            >
                {isNullOrUndefinedOrEmpty(item.name) ? 'No name' : item.name}
            </IressButton>
        ),
        nameStringValue: isNullOrUndefinedOrEmpty(item.name) ? 'No name' : item.name,
        isCompletedCell: item.isCompleted ? (
            <IressText>
                <IressIcon mode="success" name={'check'} /> Updated / reviewed
            </IressText>
        ) : (
            <IressText>
                <IressIcon mode="danger" name={'ban'} /> Must be reviewed
            </IressText>
        ),
        isCompletedString: isNullOrUndefinedOrEmpty(item.isCompleted) ? 'false' : String(item.isCompleted),
    }));
};

export const CurrentPlanProjectionsTable: FC<CurrentPlanProjectionsTableProps> = props => {
    const { currentPlanProjections, entityId, scenarioId, ownerId } = props;
    const rows = useProjectionsTableRows(currentPlanProjections, entityId, scenarioId, ownerId);

    return (
        <IressTable
            className={'xps-table'}
            caption={'Selected plans'}
            hiddenCaption
            scope="col"
            rows={rows}
            columns={columnDefs}
            empty={'No current plan projections available'}
        />
    );
};
